import React from 'react'
import { FormatDate } from '../../../../../../../helpers/datetime'
import PropTypes from "prop-types"

const UpdateTable = ({ data }) => {
  return <table className="table table-striped">
    <thead>
      <tr>
        <th />
        <th colSpan="2">Drivers</th>
      </tr>
      <tr>
        <th>Start</th>
        <th>From</th>
        <th>To</th>
      </tr>
    </thead>
    <tbody>
      {data.map((item) => {
        return <tr key={item.Start}>
          <td>{FormatDate(item.Start)}</td>
          <td>{item.From.ActiveDrivers}</td>
          <td>{item.To.ActiveDrivers}</td>
        </tr>
      })}
    </tbody>
  </table>
}

UpdateTable.propTypes = {
  data: PropTypes.array
}

export default UpdateTable



// WEBPACK FOOTER //
// ./src/containers/pools/details/logs/components/poolShiftsUpdated/updateTable/index.js